// extracted by mini-css-extract-plugin
export default {"container":"Content_container__ZBGq8"};